// extracted by mini-css-extract-plugin
export default {"textField":"modalServices_textField__KKdva","checkbox":"modalServices_checkbox__YFtXI","dropzoneArea":"modalServices_dropzoneArea__8pxm4"};